export const rules = {
  firstName: {
    Customer: {
      LEAP: {
        disabled: true
      },
      Portal: {
        disabled: false
      }
    },
    Employee: {
      OKTA: {
        disabled: true
      }
    }
  },
  lastName: {
    Customer: {
      LEAP: {
        disabled: true
      },
      Portal: {
        disabled: false
      }
    },
    Employee: {
      OKTA: {
        disabled: true
      }
    }
  },
  email: {
    Customer: {
      LEAP: {
        disabled: true
      },
      Portal: {
        disabled: false
      }
    },
    Employee: {
      OKTA: {
        disabled: true
      }
    }
  },
  role: {
    Customer: {
      LEAP: {
        disabled: true
      },
      Portal: {
        disabled: false
      }
    },
    Employee: {
      OKTA: {
        disabled: false
      }
    }
  },
  phone: {
    Customer: {
      LEAP: {
        disabled: true
      },
      Portal: {
        disabled: false
      }
    },
    Employee: {
      OKTA: {
        disabled: false
      }
    }
  },
  userType: {
    Customer: {
      LEAP: {
        disabled: true
      },
      Portal: {
        disabled: true
      }
    },
    Employee: {
      OKTA: {
        disabled: true
      }
    }
  },
  contractSource: {
    Customer: {
      LEAP: {
        disabled: true
      },
      Portal: {
        disabled: true
      }
    },
    Employee: {
      OKTA: {
        disabled: true
      }
    }
  },
  submitterName: {
    Customer: {
      LEAP: {
        disabled: true
      },
      Portal: {
        disabled: true
      }
    },
    Employee: {
      OKTA: {
        disabled: true
      }
    }
  }
};

export default rules;
